import { ScrollToResults } from 'features/search/FacetsAndResults';
import React from 'react';
import { Pagination } from './Tools';

function ToolRow(props: ScrollToResults) {
	const { scrollToResults } = props;

	return (
		<div className="hawk-tool-row">
			{/* Have to decide if we need this or not. Not in design */}
			{/* <div className="hawk-tool-row__item">
				<Sorting scrollToResults={scrollToResults} />
			</div> */}

			<div className="hawk-tool-row__item">
				<Pagination scrollToResults={scrollToResults} />
			</div>
		</div>
	);
}

export default ToolRow;
